const GLOBAL_CONTENT_ALIASES: Record<string, string> = {
    '/company/about': '/pages/o-kompanii/',
    '/company/delivery': '/pages/dostavka/',
    '/customer/delivery': '/pages/dostavka/',
    '/pages/o-kompanii': '/pages/o-kompanii/',
    '/pages/dostavka': '/pages/dostavka/',
};

const GLOBAL_CONTENT_PATHS = new Set([
    '/pages/o-kompanii',
    '/pages/dostavka',
]);

function splitPathSuffix(value: string): { pathname: string; suffix: string } {
    const suffixIndex = value.search(/[?#]/);
    if (suffixIndex === -1) {
        return { pathname: value, suffix: '' };
    }

    return {
        pathname: value.slice(0, suffixIndex),
        suffix: value.slice(suffixIndex),
    };
}

function comparablePath(value: string): string {
    const { pathname } = splitPathSuffix(value);
    const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
    return normalized === '/' ? normalized : normalized.replace(/\/+$/, '');
}

/** Заменяет устаревшие информационные URL на единственный действующий адрес. */
export function normalizeGlobalContentPath(value: string): string {
    if (!value || /^(?:https?:)?\/\//.test(value) || value.startsWith('#')) {
        return value;
    }

    const { suffix } = splitPathSuffix(value);
    const canonical = GLOBAL_CONTENT_ALIASES[comparablePath(value)];
    return canonical ? `${canonical}${suffix}` : value;
}

/** Эти CMS-страницы не зависят от региона и не должны получать /geo/:code/. */
export function isGlobalContentPath(value: string): boolean {
    return GLOBAL_CONTENT_PATHS.has(comparablePath(normalizeGlobalContentPath(value)));
}
